import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { AiOutlineHome, AiOutlineShoppingCart, AiOutlineDollarCircle, AiOutlineCrown, AiOutlineQuestionCircle, AiOutlineUser, AiOutlineGlobal } from "react-icons/ai";
import styles from "./Sidebar.module.css";

const homeItems = [
  { name: "Portal", icon: <AiOutlineGlobal />, path: "/" },
];

const navItems = [
  { name: "Dashboard", icon: <AiOutlineHome />, path: "/dashboard" },
  { name: "Your Listings", icon: <AiOutlineCrown />, path: "/dashboard/listings" },
  { name: "Purchased", icon: <AiOutlineShoppingCart />, path: "/dashboard/purchased" },
  { name: "Finances", icon: <AiOutlineDollarCircle />, path: "/dashboard/finances" },
];

const profileItems = [
  { name: "Account Details", icon: <AiOutlineUser />, path: "/dashboard/account-details" },
  { name: "Help Center", icon: <AiOutlineQuestionCircle />, path: "/dashboard/help" },
];

const Sidebar = ({ className = "", onNavItemClick, isVisible }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const renderNavItems = (items) =>
    items.map((item, index) => (
      <Box 
        key={index}
        className={`${styles.navigationItem} ${isActive(item.path) ? styles.active : ""}`}
        onClick={() => {
          navigate(item.path);
          if (onNavItemClick) onNavItemClick();
        }}
      >
        <div className={styles.icon}>{item.icon}</div>
        <Typography className={styles.linkText}>{item.name}</Typography>
      </Box>
    ));


  const handleLogout = async () => {
    try {
      await fetch(`${import.meta.env.VITE_API_BASE}/api/logout`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
    } catch (err) {
      console.error("❌ Logout failed:", err);
    }

    localStorage.removeItem("authToken");
    localStorage.removeItem("authRefreshToken");
    navigate("/");
  };

  return (
    <Box className={`${styles.sidebar} ${isVisible ? styles.visible : ""} ${className}`}>

      {renderNavItems(homeItems)}
      {/* Manage Listings Section */}
      <Typography className={styles.sectionTitle}>Manage Listings</Typography>
      {renderNavItems(navItems)}

      {/* Profile Settings Section */}
      <Typography className={styles.sectionTitle}>Profile Settings</Typography>
      {renderNavItems(profileItems)}

      {/* Exit Section */}
      <Box className={styles.exitContainer}>
        <Box className={styles.exitLine} />
        <Box className={styles.exitSection} onClick={handleLogout}>
          <div className={styles.icon}>⎋</div>
          <Typography className={styles.exitText}>Exit</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Sidebar;